import { Component, Input } from '@angular/core';

@Component({
  selector: 'ds-premium-cost',
  templateUrl: './premium-cost.component.html',
  styleUrls: ['./premium-cost.component.scss'],
  standalone: false
})
export class PremiumCostComponent {
  @Input() monthlyPremium: string;
  @Input() totalCost: number;
  @Input() termMonths: number;
  @Input() title?: string;

  constructor() {}
}
